/* HAUS OF MX — Quick Add: "Find my size" redirects to PDP.
   Scope: Quick Add modal ONLY. Does NOT modify mx-dropdown.js,
   dropdown geometry, or any size-recommender asset. */
(function () {
  function getProductUrl(scope) {
    var pf = scope.querySelector('product-form-component');
    var u = pf && pf.getAttribute('data-product-url');
    if (u) return u;
    var link = scope.querySelector('.product-header a');
    return link ? link.getAttribute('href') : null;
  }
  function closeModal() {
    var dlg = document.querySelector('quick-add-dialog, dialog.quick-add-modal');
    try { if (dlg && typeof dlg.close === 'function') { dlg.close(); return; } } catch (e) {}
    var cb = document.querySelector(
      'dialog.quick-add-modal [aria-label*="close" i], dialog.quick-add-modal .close-button'
    );
    if (cb) cb.click();
  }
  document.addEventListener('click', function (ev) {
    var btn = ev.target && ev.target.closest ? ev.target.closest('.mx-dd__size-reco') : null;
    if (!btn) return;
    var scope = btn.closest('#quick-add-modal-content, .quick-add-modal__content');
    if (!scope) return;                 // PDP / other contexts untouched
    var url = getProductUrl(scope);
    if (!url) return;                   // fail-safe: leave default behaviour
    ev.preventDefault();
    ev.stopImmediatePropagation();      // prevent mx-dropdown's recommender open
    closeModal();
    setTimeout(function () { window.location.href = url; }, 60);
  }, true);                             // capture phase
})();